/** Kampfmittelauskunft product id. */
export const KampfmittelauskunftProductId = 4258 // this product belongs to the Authorities Documents category
